import { useEffect } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { DepartureProtocolAttachmentCreation, DepartureProtocolObjAttValidation, GetAllDepartureProtocolAttachments, resetDepartureProtocolAttachmentCreationStatus, resetDepartureProtocolObjAttErrors, resetPPAttCreationRequest, setPPAttCoding, setPPAttDescription } from "../departure/slice";

interface Props {
    close: () => void
}

export function AddAttachmentPopupDeparture(props: Props) {
    const dispatch = useAppDispatch()
    const departureProtocolState = useAppSelector(state => state.departureProtocol)

    useEffect(() => {
        if (departureProtocolState.departureProtocolObjAttValidationStatus === 'successfully') {
            dispatch(resetDepartureProtocolObjAttErrors())
            dispatch(DepartureProtocolAttachmentCreation(departureProtocolState.departureProtocolAttachmentCreationRequest))
        }
    }, [departureProtocolState.departureProtocolObjAttValidationStatus])

    useEffect(() => {
        if (departureProtocolState.departureProtocolAttachmentCreationStatus === 'successfully') {
            dispatch(resetDepartureProtocolAttachmentCreationStatus())
            dispatch(resetPPAttCreationRequest())
            dispatch(GetAllDepartureProtocolAttachments({
                itemsPerPage: 0,
                page: 0
            }))
            props.close();
        }
    }, [departureProtocolState.departureProtocolAttachmentCreationStatus])

    return (
        <Fragment>
            <div className="bg-brandPrimary-100 p-6 gap-4 flex flex-col " style={{ flex: 0.7, borderTopRightRadius: '16px' }}>X
                <MadfarmInput
                    error={departureProtocolState.departureProtocolObjAttErrors.coding}
                    supportingText={departureProtocolState.departureProtocolObjAttErrors.coding ? 'Codifica mancante' : undefined}
                    label={'Codifica'}
                    placeholder="Specificare codifica..."
                    value={departureProtocolState.departureProtocolAttachmentCreationRequest.coding}
                    onChangeText={(text) => dispatch(setPPAttCoding(text))}
                />

                <MadfarmInput
                    error={departureProtocolState.departureProtocolObjAttErrors.description}
                    supportingText={departureProtocolState.departureProtocolObjAttErrors.description ? 'Descrizione mancante' : undefined}
                    label={'Descrizione'}
                    placeholder="Specificare descrizione..."
                    value={departureProtocolState.departureProtocolAttachmentCreationRequest.description}
                    onChangeText={(text) => dispatch(setPPAttDescription(text))}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 24 }}>
                <ButtonComponent
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="gray"
                    onClick={() => {
                        dispatch(resetPPAttCreationRequest())
                        dispatch(resetDepartureProtocolObjAttErrors())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Aggiungi"
                        color="orange"
                        onClick={() => {
                            dispatch(DepartureProtocolObjAttValidation(departureProtocolState.departureProtocolAttachmentCreationRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}